import ls from 'local-storage';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { getRequestAsJS } from '../selectors/requestSelectors';
import { HOTELS_CACHE_VERSION } from '../constants/cacheConstants';
import { getHotelsCacheKey } from '../utils/cacheUtils';

const saveHotelsCacheThunk = (taxonomy = '') => (dispatch, getState) => {
  const state = getState();
  const locale = getActiveLocaleSelector(state);
  const CACHE_KEY = getHotelsCacheKey(locale, taxonomy);

  ls.set(CACHE_KEY, {
    ...getRequestAsJS(state),
    locale,
    version: HOTELS_CACHE_VERSION,
    timestamp: Date.now(),
  });
};

export default saveHotelsCacheThunk;
